import React from "react";
import { ButtonLink } from "components/common/Button";
import { CombinedEvent } from "components/events/queries";
import styles from "./Event.module.css";

type EventRegisterProps = {
  event: CombinedEvent;
  startDay: string | null;
};

const SidebarRegistered: React.FC<EventRegisterProps> = ({ event, startDay }) => {
  return (
    <>
      <div className={styles.sidebarRegistered}>Registered</div>
      {event.userEventDetails?.joinUrl && (
        <div className={styles.sidebarJoinEvent}>
          <ButtonLink
            href={event.userEventDetails.joinUrl}
            target="_blank"
            rel="nooopener noreferrer"
          >
            Enter Zoom Webinar
          </ButtonLink>
          {event.eventFields?.handoutUrl && (
            <ButtonLink
              href={event.eventFields.handoutUrl}
              target="_blank"
              rel="nooopener noreferrer"
              theme="secondary"
              className={styles.marginTop}
            >
              Download Webinar Handout
            </ButtonLink>
          )}
          <div className={styles.marginTop}>
            <b>Please note:</b>
            <br />
            You will not be able to join the webinar until it is ready to start, on {startDay}.
          </div>
        </div>
      )}
    </>
  );
};

export default SidebarRegistered;
